/**
 * Session du membre côté client (Mon compte v2).
 */

/**
 * Le membre peut-il changer son mot de passe ici ? Pas en OAuth (comme la v1). Le drapeau `uxV2.canChangePassword`
 * n'est émis par aucun code serveur aujourd'hui (AuthService::updatePassword vérifie l'ancien mot de passe avec
 * l'e-mail de la session, sans uid Firebase) : la branche ne sert que si le serveur l'émet un jour.
 */
export function canChangePassword(): boolean {
  if (typeof mondayMindbody === 'undefined' || !mondayMindbody) return false;
  if (mondayMindbody.oauth?.enabled) return false;
  const flag = (mondayMindbody.uxV2 as { canChangePassword?: boolean } | undefined)?.canChangePassword;
  return flag !== false;
}

/**
 * Titre selon l'intention (revue du 04/10 : « … pour réserver » s'affichait aussi au panier) : acheter (panier,
 * tarifs), réserver (Mon compte, maquette 27), parrainer (Mon compte vers sa carte « Parrainage »), sinon
 * « Connectez-vous » (pages de Mon compte). `pathname` : page demandée par le visiteur avant la connexion (état de
 * navigation), sinon la page courante ; `hash` : ancre de la page courante (#/account#parrainage : bouton « Parrainer un
 * proche » des sites, revue du 07/10 — « pour réserver » s'affichait à qui venait parrainer).
 */
export function signInTitle(pathname: string, hash = ''): string {
  // Panier d'un abonnement : « pour souscrire », comme son bouton « Souscrire » (revue du 05/10).
  if (/^\/checkout\/contract(\/|$)/.test(pathname)) return 'Connectez-vous pour souscrire';
  if (/^\/(checkout|tarifs)(\/|$)/.test(pathname)) return 'Connectez-vous pour acheter';
  if ((pathname === '/account' || pathname === '/account/') && hash === '#parrainage') return 'Connectez-vous pour parrainer';
  if (pathname === '/account' || pathname === '/account/' || pathname === '/') return 'Connectez-vous pour réserver';
  return 'Connectez-vous';
}
